import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICompaniesGroups, IGroupFilterRequest } from '../models/companies-groups.model';
import { IPageCount } from 'src/app/shared/models/page.model';
import { APIResponse } from 'src/app/core/models/api-response';
import { join } from '@sentry/core';

@Injectable({
  providedIn: 'root'
})
export class CompaniesGroupsService {

  constructor(
    private http: HttpClient
  ) { }

  public listCompaniesGroups(includes?: Array<string>): Observable<APIResponse<ICompaniesGroups>> {
    let params = new HttpParams();
    if (includes) {
      params = params.set('includes', includes.join(','));
    }
    return this.http.get<APIResponse<ICompaniesGroups>>(`${environment.BASE_URL_API}location-groups`, { params });
  }

  public companiesGroups(page: IPageCount,
    filter: IGroupFilterRequest | undefined,
    search: string | undefined): Observable<APIResponse<ICompaniesGroups>> {
    const params = new HttpParams()
      .set('page', page.number)
      .set('limit', page.size)
      .set('filters', JSON.stringify(filter))
      .set('key', search!);
    return this.http.get<APIResponse<ICompaniesGroups>>(`${environment.BASE_URL_API}location-groups`, { params });
  };

  public addCompaniesGroups(payload: Omit<ICompaniesGroups, 'id'>): Observable<APIResponse<ICompaniesGroups>> {
    return this.http.post<APIResponse<ICompaniesGroups>>(`${environment.BASE_URL_API}location-groups`, payload);
  };

  public getCompaniesGroupsById(id: number): Observable<APIResponse<ICompaniesGroups>> {
    return this.http.get<APIResponse<ICompaniesGroups>>(`${environment.BASE_URL_API}location-groups/${id}`);
  };

  public editCompaniesGroups(id: number, payload: Omit<ICompaniesGroups, 'id'>): Observable<APIResponse<ICompaniesGroups>> {
    return this.http.patch<APIResponse<ICompaniesGroups>>(`${environment.BASE_URL_API}location-groups/${id}`, payload);
  };
  public deleteCompaniesGroups(id?: number): Observable<any> {
    return this.http.delete<APIResponse<ICompaniesGroups>>(
      environment.BASE_URL_API + 'location-groups/' + id,
    );
  }

}
